<template>
  <div>
    <base-header type="gradient-success" />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">Tip Splits</h3>
            </div>
            <div class="col text-right">
              <a
                href="#!"
                @click.prevent="showNewModal = true"
                class="btn btn-sm btn-info"
              >
                New Tip Split
              </a>
            </div>
          </div>
        </div>

        <!-- reports table -->
        <div class="table-responsive">
          <table class="table tablesorter">
            <thead class="thead-light">
              <tr>
                <th>Report Date</th>
                <!-- <th>Report Id</th> -->
                <th>Status</th>
                <th>Run by</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="">
              <TipSplitsRow
                v-for="tipSplit in tipSplits"
                :key="tipSplit.reportId"
                :tipSplit="tipSplit"
                @downloadTipSplit="downloadTipSplit"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <NewTipSplitModal
      v-if="showNewModal"
      :showModal="showNewModal"
      @close="showNewModal = false"
    />
  </div>
</template>
<script>
import TipSplitsRow from "./TipSplitsRow";
import NewTipSplitModal from "@/components/NewTipSplitModal.vue";

export default {
  async created() {
    await this.fetchTipSplits();
  },
  components: {
    TipSplitsRow,
    NewTipSplitModal,
  },
  data() {
    return {
      keywords: "",
      showNewModal: false,
    };
  },
  computed: {
    tipSplits() {
      return this.$store.state.tipSplits;
    },
  },
  methods: {
    async fetchTipSplits() {
      const response = await this.$store.dispatch("callAPI", {
        action: "getSplitReports",
      });
      this.$store.commit("set", ["tipSplits", response.data.data]);
    },
    async downloadTipSplit(tipSplit) {
      console.log("downloadTipSplit", tipSplit);
    },
  },
};
</script>

<style lang="scss"></style>
